const newTaskPriorityMenuTexts = {
  priority1: 'Priority 1',
  priority2: 'Priority 2',
  priority3: 'Priority 3',
  priority4: 'Priority 4',
}

export default newTaskPriorityMenuTexts
